import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
const swal = require('sweetalert');
import { Router, ActivatedRoute } from "@angular/router";
import { PayoutService } from 'src/app/services/payout.service';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import * as uuid from 'uuid';



@Component({
  selector: 'app-payout-contacts',
  templateUrl: './payout-contacts.component.html',
  styleUrls: ['./payout-contacts.component.scss']
})
export class PayoutContactsComponent implements OnInit {
  PCountry: any;
  PState: any;
  Pcity: any;
  responsetext: any;
  isCustomerAccountIdHidden: boolean = true;
  isCustomerIdHidden: boolean = true;
  isCompanyNameHidden: boolean = true;
  isFirstNameHidden: boolean = true;
  isLastNameHidden: boolean = true;
  isAddressHidden: boolean = true;
  isCityHidden: boolean = true;
  isStateHidden: boolean = true;
  isZipCodeHidden: boolean = true;
  isCountryHidden: boolean = true;
  isMobileNoHidden: boolean = true;
  isMobileNo2Hidden: boolean = true;
  isEmailHidden: boolean = true;
  isEmail2Hidden: boolean = true;
  isimgHidden: boolean;







  AccountIdnonmandatory: boolean = true;
  AccountIdmandatory: boolean = false;
  servicesslist = [];
  CustomerAccountkeyid: boolean = false;
  Workclose = true;
  step1 = true;
  noAmount = false;
  rows;
  CustomerIdkeyid: boolean = false;
  stateList: any;
  //   public stateList: Array<string> = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
  //   'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa',
  //   'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Orissa', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
  //   'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  // ];
  public CountryList: Array<string> = ['India'];
  CustomerAccountId = new FormControl("", [Validators.required]);
  PayoutCustomerkeyId = new FormControl("", [Validators.required]);
  CustomerId = new FormControl("", [Validators.required]);
  CompanyName = new FormControl("", []);
  FirstName = new FormControl("", [Validators.required, Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  LastName = new FormControl("", [Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  Address = new FormControl("", [Validators.required, Validators.required]);
  City = new FormControl("", [Validators.required, Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  State = new FormControl("", [Validators.required, Validators.pattern("")]);
  ZipCode = new FormControl("", [Validators.pattern("^(?!000000)[0-9]{6}$")]);
  Country = new FormControl("", [Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  MobileNo = new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  MobileNo2 = new FormControl("", [Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  Email = new FormControl("", []);
  Email2 = new FormControl("", []);
  UserDefined1 = new FormControl("", []);
  UserDefined2 = new FormControl("", []);
  UserDefined3 = new FormControl("", []);
  UserDefined4 = new FormControl("", []);
  UserDefined5 = new FormControl("", []);
  UserDefined6 = new FormControl("", []);
  UserDefined7 = new FormControl("", []);
  UserDefined8 = new FormControl("", []);
  UserDefined9 = new FormControl("", []);
  UserDefined10 = new FormControl("", []);
  custMobileNo = new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  PayoutCustomerKeyId: any;
  constructor(private router: Router, private service: PayoutService, private commonfunction: CommonFunctionService,) { }

  ngOnInit() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.stateList = this.commonfunction.getStatesList();
    this.createCustomerAccount();
    //  this.service.ViewAccountBalance(merchantdata.MerchantKeyId).subscribe(result => {
    //   if(result !=null)
    //   {
    //     this.rows=result; 
    //     this.noAmount= true;
    //    }
    //    else{
    //     this.rows.CurrentBalance = 0;
    //     this.noAmount= false;
    //    }

    // }) 

  }

  NewPayOut() {
    let form = {
      PayoutCustomerkeyId: "",
      CustomerId: "",
      CompanyName: "",
      FirstName: "",
      LastName: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      MobileNo: "",
      MobileNo2: "",
      Email: "",
      Email2: "",
      UserDefined1: "",
      MerchantKeyId: 0,
      UpdatedUserName: "",
      UserDefined2: "",
      UserDefined3: "",
      UserDefined4: "",
      UserDefined5: "",
      UserDefined6: "",
      UserDefined7: "",
      UserDefined8: "",
      UserDefined9: "",
      UserDefined10: "",
      CustomerAccountId: "",
      LoginUserId: ''


    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    //   const myId = uuid.v4();
    //   var uniqueid=myId.substring(0,5);
    //  form.PayoutCustomerkeyId= "M"+ merchantdata.MerchantKeyId+"C" +uniqueid;
    form.CustomerId = this.CustomerId.value;
    form.CompanyName = this.CompanyName.value;
    form.FirstName = this.FirstName.value;
    form.LastName = this.LastName.value;
    form.Address = this.Address.value;
    form.City = this.City.value;
    form.State = this.State.value;
    form.ZipCode = this.ZipCode.value;
    form.Country = this.Country.value;
    form.MobileNo = this.MobileNo.value;
    form.MobileNo2 = this.MobileNo2.value;
    form.Email = this.Email.value;
    form.Email2 = this.Email2.value;
    form.UserDefined1 = this.UserDefined1.value;
    form.UserDefined2 = this.UserDefined2.value;
    form.UserDefined3 = this.UserDefined3.value;
    form.UserDefined4 = this.UserDefined4.value;
    form.UserDefined5 = this.UserDefined5.value;
    form.UserDefined6 = this.UserDefined6.value;
    form.UserDefined7 = this.UserDefined7.value;
    form.UserDefined8 = this.UserDefined8.value;
    form.UserDefined9 = this.UserDefined9.value;
    form.UserDefined10 = this.UserDefined10.value;
    form.CustomerAccountId = this.CustomerAccountId.value;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.newpayout(form).subscribe(result => {

      if (result != null) {
        this.PayoutCustomerKeyId = result.PayoutCustomerkeyId;

        if (result.Errorresponse != null && result.Errorresponse.length > 0) {
          if (result.Errorresponse[0].DeveloperMessage != null) {
            this.responsetext = result.Errorresponse[0].DeveloperMessage;
            this.ContactConfirmationDialog();
          }
        }
        else {
          this.ContactsuccessConfirmationDialog();
          // swal("Added", "PayOut Contact Created Successfully", "success");
          // this.router.navigate(["PayOut/ManagePayOutContact"]);
          // this.router.navigate(['/PayOut/AddBeneficiaries',{Id: this.PayoutCustomerKeyId}]);
        }

      }
    });

  }


  onChange() {
    let form = { merchantKeyId: 0, Id: "", PosSubscriptionId: "" };

    let merchantdatas: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.Id = this.CustomerId.value;
    form.merchantKeyId = merchantdatas.MerchantKeyId;

    this.service.GetCustomerkeyIDDetail(form).subscribe(result => {
      if (result.length > 0) {
        this.CustomerIdkeyid = true;
      }
      else {
        this.CustomerIdkeyid = false;
      }

    });

  }

  CheckCustomerAccountId() {
    let form = { merchantKeyId: 0, Id: "", PosSubscriptionId: "" };

    let merchantdatas: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.Id = this.CustomerAccountId.value;
    form.merchantKeyId = merchantdatas.MerchantKeyId;

    this.service.GetCustomerAccountIDDetail(form).subscribe(result => {
      if (result.length > 0) {
        this.CustomerAccountkeyid = true;
      }
      else {
        this.CustomerAccountkeyid = false;
      }

    });

  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }


  toggleAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    const panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
  close() {
    this.Workclose = false;
  }
  PayoutCustomerkeyIderrors() {
    return this.PayoutCustomerkeyId.hasError("required")
      ? "PayoutCustomerkeyId is required"
      : "";
  }
  CustomerIderrors() {
    return this.CustomerId.hasError("required")
      ? "CustomerId is required"
      : "";
  }
  CompanyNameerrors() {
    return this.CompanyName.hasError("required")
      ? "CompanyName is required"
      : "";
  }

  FirstNameNameerrors() {
    return this.FirstName.hasError("required")
      ? "First Name is required"
      : this.FirstName.hasError("pattern") ? "First Name should allow only alphabets" : "";
  }

  LastNameerrors() {
    return this.LastName.hasError("required")
      ? "Last Name is required"
      : this.LastName.hasError("pattern") ? "Last Name should allow only alphabets" : "";
  }
  Addresserrors() {
    return this.Address.hasError("required")
      ? "Address is required"
      : "";
  }
  Cityerrors() {
    return this.City.hasError("required")
      ? "City is required"
      : this.City.hasError("pattern") ? "City should allow only alphabets" : "";
  }
  Stateerrors() {
    return this.State.hasError("required")
      ? "State is required"
      : "";
  }
  ZipCodeerrors() {
    return this.ZipCode.hasError("pattern")
      ? "Please Enter valid ZipCode and Must be 6 digit number only"
      : "";
  }
  Countryeerrors() {
    return this.Country.hasError("pattern") ? "Country should be allow only alphabets" : "";
  }
  MobileNoeerrors() {
    return this.MobileNo.hasError('required') ? 'MobileNo is required' :
      this.MobileNo.hasError('min') || this.MobileNo.hasError('max') ? 'Enter valid MobileNo' :
        this.MobileNo.hasError('pattern') ? 'Enter valid MobileNo' : '';
  }
  Mobil2eNoeerrors() {
    return this.MobileNo2.hasError('min') || this.MobileNo2.hasError('max') ? 'Enter valid MobileNo' :
      this.MobileNo2.hasError('pattern') ? 'Enter valid MobileNo' : '';
  }
  Emaileerrors() {
    return this.Email.hasError("pattern") ? "Enter valid Email Address" : "";

  }
  Email2eerrors() {
    return this.Email2.hasError("pattern") ? "Enter valid Email Address" : "";

  }
  CustomerAccountIderrors() {
    return this.CustomerAccountId.hasError('required') ? 'CustomerAccountId is required' :
      this.CustomerAccountId.hasError('min') || this.CustomerAccountId.hasError('max') ? 'Enter valid CustomerAccountId' :
        '';
  }



  createCustomerAccount() {
    var MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    var resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.service.getMerchantServicesAndFees(MerchantKeyId, resellerno).subscribe(result => {
      this.servicesslist = _clone(result);;
      this.servicesslist.forEach(element => {
        if (element.ServiceCode == "CVA" && element.Status == 1) {
          this.AccountIdmandatory = true;
          this.AccountIdnonmandatory = false;
        }
      });

    });

  }



  ContactConfirmationDialog() {

    swal({
      title: this.responsetext,
      text: '',
      icon: 'warning',
      buttons: {

        confirm: {
          text: 'Ok',
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        window.location.reload();
      }

    });

  }

  ContactsuccessConfirmationDialog() {

    swal({
      title: "Added",
      text: 'PayOut Contact Created Successfully',
      icon: 'success',
      buttons: {

        confirm: {
          text: 'Ok',
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        //window.location.reload();
        this.router.navigate(['/PayOut/AddBeneficiaries', { Id: this.PayoutCustomerKeyId }]);
      }

    });

  }

  Getzipcodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.Zipcodedetails(this.ZipCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {
        this.Pcity = result.CityVillageArea;
        this.PState = result.State;
        var pincode = this.PState.toLowerCase().split(' ');
        for (var i = 0; i < pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        this.PState = pincode.join(' ');
        this.PCountry = result.Country;
      }
      else {
        this.Pcity = "";
        this.PState = "";
        this.PCountry = "";
      }
    });
  }
}
